import React, { FC, memo } from 'react';

import Tag from '@components/vaults/Tag';

import useStyles from './styles.module';

interface Props {
  badges: { label: string; value: string }[];
  tags: { label: string; value: string }[];
  onTag: (value: { label: string; value: string }) => void;
}

const Tags: FC<Props> = ({ badges, tags, onTag }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.tagList}>
      {badges.map(({ label, value }) => {
        const checked = tags.some((tag) => tag.value === value);

        return (
          <Tag
            key={label}
            title={label}
            checked={checked}
            onClick={() =>
              onTag({
                label,
                value,
              })
            }
          />
        );
      })}
    </div>
  );
};

export default memo(Tags);
